import * as React from 'react';
import { useTranslation } from 'react-i18next';

import styled from 'styled-components';

import { getFontFamily } from 'services/FontService';
import { HEADER_COMPACT_MEDIA } from 'components/constants';

import { Icon, IconsNames } from '../Icon';

export interface IExitButtonProps {
  onClick: () => void;
}

export const ExitButton = ({ onClick }: IExitButtonProps) => {
  const { t } = useTranslation();

  return (
    <StyledButton
      type="button"
      onClick={onClick}
      aria-label={t('button.exit')}
      title={t('button.exit')}
    >
      <ButtonText aria-hidden="true">{t('button.exit')}</ButtonText>
      <IconWrapper aria-hidden="true">
        <Icon name={IconsNames.ExitIcon} width={16} height={18} />
      </IconWrapper>
    </StyledButton>
  );
};

const StyledButton = styled.button`
  display: flex;
  height: 100%;
  justify-content: center;
  cursor: pointer;
  background: none;
  border: none;
  align-items: center;
  padding: 0;
`;

const ButtonText = styled.p`
  font-family: ${getFontFamily('bold')};
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 17px;
  letter-spacing: 0.5px;
  text-decoration: none;
  margin: 0 12px 0 0;
  cursor: pointer;
  display: flex;
  align-items: center;

  /* Уже брейкпоинта шапки подпись уступает место меню — остаётся иконка,
   * имя кнопки — в aria-label и подсказке. */
  ${HEADER_COMPACT_MEDIA} {
    display: none;
  }
`;

const IconWrapper = styled.div`
  margin-top: 4px;
  display: flex;
  align-items: center;
`;
